import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {getDeletedLearnDatas, hardDeleteLearnData, restoreLearnData,} from "../../../redux/modules/Learn/action";

class LearnTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedLearnDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.learn.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const learnColumn = [
            {
                name: "Learn",
                path: "question",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"Learn Category Data"}
                        data={this.props.learn.datas}
                        columns={learnColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteLearnData(id)}
                        restoreAction={(id) => this.props.restoreLearnData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    learn: state.learn,
});

const mapDispatchToProps = {
    getDeletedLearnDatas,
    hardDeleteLearnData,
    restoreLearnData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(LearnTrash)
);
